import CloseIcon from '@mui/icons-material/Close';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import SearchIcon from '@mui/icons-material/Search';
import {
  IconButton,
  InputAdornment,
  TextField as MUITextField,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useCallback} from 'react';

const ICON_TYPE = {
  SEARCH: 'search',
  FILTER: 'filter',
};

const FilterTextField = ({
  value: valueProp,
  onChange,
  clearable = true,
  InputProps,
  type = ICON_TYPE.FILTER,
  ...props
}) => {
  const handleOnChange = useCallback(
    event => {
      onChange(event.target.value);
    },
    [onChange]
  );

  const handleOnClear = () => {
    onChange('');
  };

  return (
    <MUITextField
      value={valueProp}
      onChange={handleOnChange}
      placeholder="Filter"
      {...props}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              {type === ICON_TYPE.SEARCH && <SearchIcon />}
              {type === ICON_TYPE.FILTER && <FilterAltOutlinedIcon />}
            </InputAdornment>
          ),
          endAdornment: valueProp && clearable && (
            <InputAdornment position="end">
              <IconButton onClick={handleOnClear} size="small">
                <CloseIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ),
          ...InputProps,
        },
      }}
    />
  );
};

FilterTextField.propTypes = {
  clearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  InputProps: PropTypes.object,
  type: PropTypes.string,
};

export default FilterTextField;
